import React, { useState } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Sector,
} from 'recharts';
import { formatPlaceName } from '@/lib/utils';

interface ChartDataItem {
  name: string;
  value: number;
  percent: number;
  percentChange: number;
}

interface HousingStructurePieChartProps {
  data: ChartDataItem[];
}

// colors for pie chart
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A234B5', '#D5A6E2'];

const renderActiveShape = (props: any) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, value } = props;
    const { percentChange } = payload;

    const changeColor = percentChange > 0 ? 'text-green-600' : 'text-red-600';
    const changeSign = percentChange > 0 ? '+' : '';

    return (
        <g>
            <text x={cx} y={cy - 18} textAnchor="middle" fill={fill} className="font-bold text-base">
                {payload.name}
            </text>
            <text x={cx} y={cy + 5} textAnchor="middle" fill="#333" className="text-sm">
                {`Units: ${value.toLocaleString()}`}
            </text>
            <text x={cx} y={cy + 25} textAnchor="middle" fill="#666" className="text-xs">
                {`${(payload.percent * 100).toFixed(1)}% Share`}
            </text>
            {percentChange !== 0 && (
                <text x={cx} y={cy + 45} textAnchor="middle" fill="#666" className={`text-xs ${changeColor}`}>
                    {`${changeSign}${percentChange.toFixed(1)}% YoY`}
                </text>
            )}
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
        </g>
    );
};


export const HousingStructurePieChart: React.FC<HousingStructurePieChartProps> = ({
  data,
}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const onPieEnter = (_: any, index: number) => {
        setActiveIndex(index);
    };

  if (!data || data.length === 0) {
    return <div className="flex items-center justify-center h-full text-gray-500">No data available for chart.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          activeIndex={activeIndex}
          activeShape={renderActiveShape}
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={90}
          outerRadius={140}
          fill="#8884d8"
          dataKey="value"
          onMouseEnter={onPieEnter}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}; 